<template>
  <div class="box box-primary">
    <div class="box-header with-border">
      <div
        style="text-align:center; font-size: 20px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
      >
        {{ $route.params.id ? $t('newsManagement.categoriesObj.update') : $t('newsManagement.categoriesObj.add') }}
      </div>
    </div>
    <form class="form-horizontal">
      <div class="box-body">
        <div class="form-group required">
          <label class="col-sm-3 control-label">{{
            $t('newsManagement.residentNews.title')
          }}</label>
          <div class="col-sm-6">
            <input
              v-model="title"
              type="text"
              class="form-control"
              :placeholder="$t('newsManagement.residentNews.title')"
            />
          </div>
        </div>
      </div>
      <div class="box-footer">
        <button
          type="button"
          class="btn btn-labeled btn-danger"
          style="margin-right: 5px; background-color: #f29911;border-color: #f29911;"
          @click="onBack"
        >
          <span class="btn-label"> <i class="fa fa-mail-reply"></i> </span>
          {{ $t("common.back") }}
        </button>

        <button
          type="button"
          class="btn btn-labeled btn-success pull-right"
          style="margin-right: 5px;"
          @click="onCreateNewsCategory"
        >
          <span class="btn-label">
            <i class="glyphicon glyphicon-ok"></i>
          </span>
          {{ $t("common.save") }}
        </button>
      </div>
    </form>
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import LTECoreAlert from "@/components/LTESnackBar.vue";
// import utils from '@/lib/utils'

export default {
  name: "NewsCategoryAdd",
  data() {
    return {
      isLoading: false,
      title: null
    };
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR"
    ])
  },
  watch: {
  },
  created () {
    let newsCategoryId = this.$route.params.id
    if (newsCategoryId) {
      this.GET_NEWS_CATEGORY_DETAIL({ id: newsCategoryId }).then(
        function (res) {
          this.title = res.title
        }.bind(this)
      )
    }
  },
  methods: {
    /**
     * Create banner
     */
    onCreateNewsCategory: async function () {
        let filter = {
          title: this.title
        }
        let newsCategoryId = this.$route.params.id
        if (newsCategoryId) {
          this.UPDATE_NEWS_CATEGORY({id: newsCategoryId, ...filter}).then(
            function () {
              this.SUCCESS_TOAST()
            }.bind(this)
          ).catch(
            function () {
              this.ERROR_TOAST()
            }.bind(this)
          )
        } else {
          this.CREATE_NEWS_CATEGORY(filter).then(
            function () {
              this.title = null
              this.SUCCESS_TOAST()
            }.bind(this)
          ).catch(
            function () {
              this.ERROR_TOAST()
            }.bind(this)
          )
        }
    },
    /**
     * Back
     */
    onBack: function () {
        window.history.back()
    },
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "CREATE_NEWS_CATEGORY",
      "UPDATE_NEWS_CATEGORY",
      "GET_NEWS_CATEGORY_DETAIL"
    ]),
  },
  components: {
    Loading,
    "lte-core-alert": LTECoreAlert
  }
};
</script>
<style scoped>
.form-group.required .control-label:after {
  color: #d00;
  position: absolute;
  margin-left: 8px;
  margin-top: -3px;
  font-family: "FontAwesome";
  font-weight: normal;
  font-size: 9px;
  content: "\f069";
}
.banner-img-class{
  width: 80%;
  cursor: pointer;
}
input[type="file"] {
  display: none;
}
.remove-banner-img{
  color: #EF5350;
  cursor: pointer;
}
.remove-banner-img:hover{
  text-decoration: underline;
}
.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 25px;
  width: 100%;
  border-radius: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/News/NewsCategoryAdd.vue